<template src="./template/index.html"></template>
<script>
import Datepicker from "vuejs-datepicker";
import DibbleJS from "../../../dibble";
import DibbleAPI from "@/api";
import DibbleApi from "@/api";
import {required} from "vuelidate/lib/validators";

export default {
    name: "AddDiscountModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            default: () => {
                return null
            }
        },
    },
    components: { Datepicker },
    data() {
        return {
            dibbleJs: DibbleJS,
            effective_ons: [
                {id: 1, label: 'Rental'},
                {id: 2, label: 'Add ons'},
                {id: 3, label: 'Fuel'},
                {id: 4, label: 'Damage'},
            ],
            code: '',
            name: '',
            effective_on: '',
            value: '',
            is_percent: 0,
            can_be_added_by_client: 0,
            valid_from: '',
            valid_to: '',
            is_disabled: 0
        }
    },
    computed: {
        isAddMode() {
            return this.item === null
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        submitDiscount () {
            const params = {
                request: this.isAddMode ? DibbleAPI.api.addDiscount : DibbleAPI.api.updateDiscount,
                code: this.code,
                name: this.name,
                effective_on: this.effective_on,
                value: this.value,
                is_percent: this.is_percent,
                can_be_added_by_client: this.can_be_added_by_client
            }

            if (this.valid_from) {
                params.valid_from = this.valid_from;
            }
            if (this.valid_to) {
                params.valid_to = this.valid_to;
            }

            if (!this.isAddMode) {
                params.is_disabled = this.is_disabled;
            }

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message);
                    this.$emit("saved");
                    this.resetForm();
                } else {
                    DibbleJS.toastErrorMessage(response.message);
                }
            });
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        _formatDatetimeOutputForApi(m) {
            return this.$moment(m).format("YYYY-MM-DD") + " 00:00:00";
        },
        validationStatusClass(validation) {
            return {
                'validation-error': validation.$dirty && validation.$error,
                'validation-dirty': validation.$dirty
            };
        },
        resetForm() {
            this.code = '';
            this.name = '';
            this.effective_on = '';
            this.value = '';
            this.is_percent = 0;
            this.can_be_added_by_client = 0;
            this.valid_from = '';
            this.valid_to = '';
            this.is_disabled = 0;
        }
    },
    watch: {
        item(val) {
            if (val) {
                this.code = val.code;
                this.name = val.name;
                this.effective_on = val.effective_on;
                this.value = val.value;
                this.is_percent = val.is_percent;
                this.can_be_added_by_client = val.can_be_added_by_client;
                this.valid_from = val.valid_from;
                this.valid_to = val.valid_to;
                this.is_disabled = val.is_disabled;
            } else {
                this.resetForm();
            }
        }
    },
    validations: {
        code: { required },
        name: { required },
        effective_on: { required },
        value: { required },
    }
}
</script>

<style lang="scss">
.modal {
    background: transparent;
    transition: opacity 0.15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .modal-form {
        display: flex;
        height: auto;
        align-items: center;
        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 8px;
            width: 100%;
            .title {
                font-size: 14px;
                margin: 0;
                margin-right: 10px;
            }
        }
    }
    button {
        float: right;
    }
}
.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}

.dollar-sign-prepend {
 color: #969fa2;
 position: absolute;
 bottom: 10px;
 left: 13px;
 font-size: 16px;
}
</style>
